import React from "react";
import { ListGroup, Badge } from "react-bootstrap";
import styled from "styled-components";
import { ServicioTransporte } from "../../services/transporteServicios";
import { currencyFormat } from "../../utils/numberUtils";

const ListaTarifas = ({
  tarifas,
  onSeleccionarTarifa,
  tarifaSeleccionada,
}: {
  tarifas: ServicioTransporte[];
  onSeleccionarTarifa: (tarifa: ServicioTransporte) => void;
  tarifaSeleccionada?: ServicioTransporte;
}) => {
  return (
    <div>
      <div className="mb-2">Seleccione la tarifa:</div>

      <ListGroup as="ul">
        {tarifas.map((tarifa) => (
          <StyledListGroupItem
            action
            onClick={() => {
              onSeleccionarTarifa(tarifa);
            }}
            className="d-flex justify-content-between align-items-start"
            active={tarifa.id === tarifaSeleccionada?.id}
            key={tarifa.id}
          >
            <div className="ms-2 me-auto">
              <div className="fw-bold">{tarifa.nombre}</div>
              <div>{tarifa.descripcion}</div>
            </div>
            <div className="ms-2 me-auto"></div>
            <Badge bg="success" pill>
              {currencyFormat(tarifa.precio)}
            </Badge>
          </StyledListGroupItem>
        ))}
      </ListGroup>
    </div>
  );
};

const StyledListGroupItem = styled(ListGroup.Item)`
  &.active {
    z-index: 2;
    background-color: ${(props) => props.theme.colors.mainShadow};
    border-color: ${(props) => props.theme.colors.main};
    color: #212529;
  }
`;

export default ListaTarifas;
